import SetPasswordContainer from "./SetPasswordContainer";

export default SetPasswordContainer;
